export const NOTIFICATION_MESSAGES = {
  USER_CREATED: (user) => 
    `🆕 New user registered: ${user.name ? `${user.name} (${user.email})` : user.email}`,

  PLAN_REQUEST: (user) => 
    `🔔 Plan request received from ${user.email}${user.planName ? ` for plan "${user.planName}"` : ''}`,
};